
export const AlignBottom = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 6L9.5 15.6L11 15.6L11 6L9.5 6ZM13 9.6L13 15.6L14.5 15.6L14.5 9.6L13 9.6ZM7 16.8L7 18L17 18L17 16.8L7 16.8Z" fill={color}/>
    </svg> 
  );
}